import components from "./components"
import * as selectors from "./selectors"
import makeReducers from "./reducers"
import * as actions from "./actions"
import * as fn from "./fn"
import { definitions, taggedOperations } from "../spec/selectors"
import React from "react"
export default (system) =>
  ({
    components: {
      ...components,
      // eslint-disable-next-line react/prop-types
      MatcherSelectOption_operationSummary: ({ getComponent, matcherKey }) => {
        const MatcherSelectOption = getComponent("MatcherSelectOption", true)
        require("react")
        return (
          // eslint-disable-next-line react/jsx-filename-extension,react/react-in-jsx-scope
          <MatcherSelectOption matcherKey={matcherKey} label="operation summary" />
        )
      }
    },
    fn,
    statePlugins: {
      advancedFilter: {
        selectors,
        actions,
        reducers: makeReducers(system),
      },
      spec: {
        selectors: {
          taggedOperations: (state) => ({ getSystem }) => {
            const { advancedFilterSelectors } = getSystem()
            if (advancedFilterSelectors.isEnabled() && advancedFilterSelectors.getPhrase() !== "") {
              const filteredSpec = advancedFilterSelectors.getFilteredSpec()
              state = state
                .set("resolvedSubtrees", filteredSpec)
                .set("json", filteredSpec)
            }
            return taggedOperations(state)(getSystem())
          },
          definitions: (state) => ({ getSystem }) => {
            const { advancedFilterSelectors } = getSystem()
            if (advancedFilterSelectors.isEnabled() && advancedFilterSelectors.getPhrase() !== "") {
              const filteredSpec = advancedFilterSelectors.getFilteredSpec()
              state = state
                .set("resolvedSubtrees", filteredSpec)
                .set("json", filteredSpec)
            }
            return definitions(state)
          },
        },
      },
    },

  })
